import { Value } from '@philips-internal/oswald-ui-core';

export class SavedRecordsContext {
  static state: Record<string, Value>;

  static set(data: Record<string, Value>): void {
    this.state = data;
  }

  static clean(): void {
    this.state = {};
  }

  static get(): Record<string, Value> {
    return this.state;
  }
}
